'use strict';

jQuery($ => {
    $('.gecko-builder-video-gallery__section').each((i, ui) => {
        const section = $(ui);
        const title = section.find('.gecko-builder-video-gallery__section-title');

        title.on('click', (e) => {
            e.preventDefault();
            if (section.attr('data-status') === 'active') {
                section.removeAttr('data-status');
            } else {
                section.attr('data-status', 'active');
            }
        });
    });

    $('.gecko-builder-video-gallery__video').each((i, ui) => {
        const button = $(ui);
        const videoKey = button.attr('data-video-key');

        button.on('click', (e) => {
            e.preventDefault();
            if (modal.attr('data-status') === 'active') {
                modal.removeAttr('data-status');
            } else {
                modal.attr('data-status', 'active');
            }
        });

        const modal = $('.gecko-builder-video-gallery__modal[data-video-key="' + videoKey + '"]');
        const overlay = modal.find('.gecko-builder-video-gallery__modal-overlay');
        const iframe = modal.find('iframe');
        const newSrc = iframe.attr('src');

        modal.attr('data-src', newSrc);

        overlay.on('click', (e) => {
            e.preventDefault();
            // iframe.attr('src', '');
            iframe.attr('src', newSrc);
            modal.removeAttr('data-status');
        });
    });
});
